export default "__VITE_ASSET__OSwHldRq__"